import { Injectable } from '@angular/core';
import { FormGroup } from "@angular/forms";
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimeValidatorService {

  constructor() { }
  timeValidator1(open1: string, close1: string) {
    return (formgroup: FormGroup) => {
      const openTime1 = formgroup.controls[open1];
      const closeTime1 = formgroup.controls[close1];

      if (!openTime1 || !closeTime1) {
        return null;
      }
      if (openTime1 && closeTime1) {
        let timeOpen = openTime1.value;
        let open1 = timeOpen.slice(0, 2);
        let timeClose = closeTime1.value;
        let close1 = timeClose.slice(0, 2);

        if (open1 == 0 && close1 == 0) {
          return null;
        }

      }

      if (
        openTime1.errors &&
        !closeTime1.errors?.timeError
      ) {
        return null;
      }

      if (openTime1.value >= closeTime1.value) {
        closeTime1.setErrors({ timeError: true });
      } else {
        closeTime1.setErrors(null);
      }
      return;
    };

  }
  timeValidator2(open2: any, close2: any) {
    return (formgroup: FormGroup) => {

      const openTime2 = formgroup.controls[open2];
      const closeTime2 = formgroup.controls[close2];

      if (openTime2.value != null && closeTime2.value != null) {
        if (!openTime2 || !closeTime2) {
          return null;
        }

        if (openTime2.errors && !closeTime2.errors?.timeError) {
          return null;
        }

        if (openTime2.value >= closeTime2.value && openTime2.value && openTime2.value !== '' ) {
          closeTime2.setErrors({ timeError: true });
        } else {
          closeTime2.setErrors(null);
        }

        if ((!openTime2.value || openTime2.value === '') && closeTime2.value)
          closeTime2.setErrors({ openWithoutValue: true });
      }
      return;
    };

  }
}
